// extracted by mini-css-extract-plugin
export var business = "Business-module--business--ca974";
export var business_button = "Business-module--business_button--e8edf";
export var business_inner = "Business-module--business_inner--5a13d";
export var business_media = "Business-module--business_media--8e8e8";
export var business_text = "Business-module--business_text--1ef15";